import SearchForm from './SearchForm.vue';
import SearchProjectsResults from './SearchProjectsResults.vue';

export default {
    SearchForm,
    SearchProjectsResults,
};